import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import AgentwiseDailyTagrget from "../home/agents/AgentwiseDailyTagrget";

const FDTargets = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: FD Targets">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <AgentwiseDailyTagrget userInfoData={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default FDTargets;
